module.exports = __webpack_public_path__ + "img/error.0d0e139c.svg";